module.exports = __webpack_public_path__ + "static/img/_jxxm.f1b7da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_jxxm.png
// module id = YMiD
// module chunks = 96